export default "__VITE_ASSET__CDEwbc36__"